var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navigation'),_c('v-card',{staticClass:"mx-auto mb-3",attrs:{"max-width":"1300"}},[_c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_vm._v("Manage offices")]),_c('v-spacer'),_c('CompanyCreatePopup',{on:{"reloadOffices":_vm.reloadOffices}})],1)],1),_c('CompaniesList',{attrs:{"reload":_vm.reload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }